import fulfillmentVendors from './fulfillmentVendors'

export default {
  fulfillmentVendors
}
